export const prepareNonFinancialForRender = data => {
  return data.map(savingsGroup => ({
    ...savingsGroup,
    non_savings_types: savingsGroup.non_savings_types.filter(savingsType => savingsType.checked),
  }));
}